// Winning scripts — source de vérité de l'app
//
// OPTION 1 — Éditer dans l'UI :
//   Modifie le texte dans la textarea "Classic Winning", clique "Save as default"
//   → sauvegardé en localStorage, persiste au reload
//
// OPTION 2 — Éditer ici dans le code :
//   1. Change le texte dans base:
//   2. Incrémente SCRIPTS_VERSION de 1
//   3. Push → le browser ignore le localStorage et prend ce nouveau texte

export const SCRIPTS_VERSION = 6; // <- incrémenter à chaque modif dans ce fichier

const WINNING_SCRIPTS = {
  ghost_mannequin: {
    label: 'Ghost Mannequin',
    base: "Don't take pictures like this. Turn any photo into a ghost mannequin. Just like the professional ones you see online. Just take a picture and let the app do its magic. You have to try it now."
  },
  product_staging: {
    label: 'Product Staging',
    base: "Tired of plain product photos? Use AI to instantly stage your products in beautiful, realistic environments. More clicks, more sales."
  },
  animated_design: {
    label: 'Animated Design',
    base: "Turn any picture to a video with this app. Just take a picture, and the AI generates many new backgrounds for you. Choose the one you want, then let the app animate it. You have to try it now."
  },
  ai_backgrounds: {
    label: 'AI Backgrounds',
    base: "Stop taking product photos with ugly backgrounds. With this app, you just take your picture, and the AI removes the background and replaces it with anything you want. A studio, a beach, a marble table — in seconds. Your photos look professional instantly. You have to try it now."
  },
  virtual_models: {
    label: 'Virtual Models',
    base: "Stop taking pictures like this. If you take a product picture, this app uses AI to put it in a very realistic model, just like the professional ones you see online. Just take a picture and let the app do its magic. You have to try it now."
  },
  flat_lay: {
    label: 'Flat Lay',
    base: "Stop taking product photos with boring backgrounds. Flat lay is the easiest way to make your product look premium — just arrange it and let the AI handle the rest. The result looks like a pro studio shot. You have to try it now."
  },
};

export default WINNING_SCRIPTS;
